import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Navigation = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  // Anchor targets only exist on the home page; elsewhere, link back to it
  const base = pathname === '/' ? '' : '/';
  // Service pages carry their own contact form; the privacy page does not
  const contactBase = pathname === '/privacy-policy' ? '/' : '';

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  const close = () => setOpen(false);

  const links = [
    { href: `${base}#services`, label: 'Services', id: 'services' },
    { href: `${base}#process`, label: 'Process', id: 'process' },
    { href: `${base}#why`, label: 'Why us', id: 'why' },
    { href: `${base}#faq`, label: 'Questions', id: 'faq' },
  ];

  return (
    <nav className={`nav${open ? ' is-open' : ''}`} data-testid="main-nav" aria-label="Main">
      <div className="nav-bar"><div className="wrap nav-inner">
        <a href="/" className="nav-brand" data-testid="nav-brand-link">
          <img src="/icons/logo.png" alt="" width="152" height="96" />
          <span>Rapid Rune</span>
        </a>
        <div className="nav-links">
          {links.map((l) => (
            <a key={l.id} href={l.href} className="nav-link" data-testid={`nav-link-${l.id}`}>
              {l.label}
            </a>
          ))}
        </div>
        <div className="nav-actions">
          <a href="https://portal.rapidrune.com" className="nav-link nav-portal" data-testid="nav-portal-link">
            Client portal
          </a>
          <a href={`${contactBase}#contact`} className="btn btn-accent nav-cta" data-testid="nav-cta-button">
            Start a project
          </a>
          <button
            type="button"
            className="nav-toggle"
            aria-expanded={open}
            aria-controls="nav-sheet"
            onClick={() => setOpen((o) => !o)}
          >
            <span className="sr-only">{open ? 'Close menu' : 'Open menu'}</span>
            <span className="nav-toggle-bars" aria-hidden="true" />
          </button>
        </div>
      </div></div>

      <div id="nav-sheet" className="nav-sheet">
        {links.map((l) => (
          <a key={l.id} href={l.href} onClick={close} tabIndex={open ? 0 : -1}>
            {l.label}
          </a>
        ))}
        <a href="https://portal.rapidrune.com" onClick={close} tabIndex={open ? 0 : -1}>
          Client portal
        </a>
        <a href={`${contactBase}#contact`} className="nav-sheet-cta" onClick={close} tabIndex={open ? 0 : -1}>
          Start a project
        </a>
      </div>
    </nav>
  );
};

export default Navigation;
